export const isTruthy = (x) => !!x;
